export const CACHE_KEY_LIST_DPJ_OFFICE = 'dpjOffices';
export const CACHE_KEY_DPJ_OFFICE = 'dpjOffice-one';
export const ROUTE_PATH_DPJ_OFFICE = '/configuration/dpj-offices';
export const TRANSLATION_PREFIX_DPJ_OFFICE = 'dpjOffice';
export const SECURITY_KEY_DPJ_OFFICE = 'DPJ';

